import { type Form } from '@wix/ambassador-forms-v4-form/types';

type HasMultilineAddressParams = {
  // TODO: remove this once ecom is migrated to multiple address templates
  //  and can be treated the same as other multiline address types
  excludeEcomAddress?: boolean;
};

export const hasMultilineAddress = (
  form: Form,
  { excludeEcomAddress }: HasMultilineAddressParams = {
    excludeEcomAddress: false,
  },
) => {
  const fields = [...(form?.fields || []), ...(form?.deletedFields || [])];
  return fields.some(
    (field) =>
      field.view?.fieldType === 'MULTILINE_ADDRESS' ||
      field.view?.fieldType === 'BOOKINGS_ADDRESS' ||
      (!excludeEcomAddress && field.view?.fieldType === 'ECOM_ADDRESS'),
  );
};
